<template>
  <LayoutPage> </LayoutPage>
</template>

<script>
import LayoutPage from "./layouts/layout-page.vue";
export default {
  name: "App",
  components: {
    LayoutPage,
  },
};
</script>

<style></style>
